// Session-lifetime promise cache for cheap, rarely-changing lookups (entity names, static lookup lists)
// that per-row components fire once per rendered row. Sharing the promise dedupes concurrent requests for
// the same id, so a 20-row grid asks the backend once per distinct id instead of once per row — this keeps
// pages under the UserLimitMiddleware request budget (429 storms on the Assignments page).
// Rejected promises are evicted, so a transient failure (e.g. a 429) is retried on the next mount instead
// of poisoning the cache until a full page reload.

const caches = new Map();

// cacheKey is compared by identity; pass a stable value (a static service method reference works well).
export function cachedLookup(cacheKey: unknown, id: unknown, fetchFunction: (id: unknown) => Promise<unknown>) {
  let byId = caches.get(cacheKey);
  if (!byId) {
    byId = new Map();
    caches.set(cacheKey, byId);
  }

  let promise = byId.get(id);
  if (!promise) {
    promise = Promise.resolve(fetchFunction(id)).catch((error) => {
      byId.delete(id);
      throw error;
    });
    byId.set(id, promise);
  }
  return promise;
}

export function clearLookupCaches() {
  caches.clear();
}
